<template>
  <div>
    <v-card
      @click="openCalculator()"
      elevation="2"
      height="28px"
      style="width:28px"
      class="pa-0 ma-0"
    >
      <v-row align="center" justify="center" class="pa-0 ma-0" style="height:100%;width:100%">
        <v-img class="pa-0 ma-0" :src="calculator" max-width="24px"></v-img>
      </v-row>
    </v-card>
    <vetalfa-calculator></vetalfa-calculator>
  </div>
</template>

<script>
import { mapMutations } from "vuex";
import images from "@/constants/images.js";
import Calculator from "@/components/Calculator.vue";
import { analytics } from "@/plugins/firebase.js";
export default {
  name: "CalculatorButton",
  components: {'vetalfa-calculator': Calculator},
  computed: {},
  props: {},
  methods: {
    ...mapMutations("general", ["setCalculatorModel"]),
    openCalculator(){
      this.analytics.logEvent("open_calculator");
      this.setCalculatorModel(true);
    }
  },
  computed: {},
  data() {
    return {      
      calculator: images.CALCULATOR,
      analytics
    };
  }
};
</script>